import { service } from '../index.js'

// 产品分类管理
export const productCategory = {
  // 分类列表（树形结构）
  list: () => {
    return service.get('/product-category/list')
  },

  // 后台：分类列表
  adminList: (params) => {
    return service.get('/product-category/admin/list', { params })
  },

  // 后台：保存分类
  save: (data) => {
    return service.post('/product-category/admin/save', data)
  },

  // 后台：删除分类
  delete: (data) => {
    return service.post('/product-category/admin/delete', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/product_category.js